import { ChangeDetectorRef, Component, ViewRef } from '@angular/core'
import { MinimizeTab } from '../../../../../Interfaces/MinimizeTab'
import { StateService } from '../../../../../services'

@Component({
	selector: 'atyl-minimize-group',
	templateUrl: './group.component.html',
	styleUrls: ['./group.component.scss']
})
export class AtylMinimizeGroupComponent {

	tabs: MinimizeTab[]

	constructor(
		private stateService: StateService,
		private changeDetectorRef: ChangeDetectorRef
	) { }

	ngOnInit() {

		this.stateService.miniminzeTabs.subscribe((tabs: MinimizeTab[]) => {
			this.tabs = tabs
			setTimeout(() => {
				if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
					this.changeDetectorRef.detectChanges()
				}
			})
		})
	}

}
